module.exports = __webpack_public_path__ + "static/img/group28_17.gif";